import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {LoggedInLayout} from "features/layouts/pages/logged-in";
import PeopleHighlights from "features/pages/people/highlights";
import PeopleFavorites from "features/pages/people/favorite";
import PeopleSearchResults from "features/pages/people/search";
import {staticDataInterests, staticDataOsaOffices} from "store/reducer/static/selectors";
import {peopleSearchFilters, peopleSearchLoading} from "features/pages/people/search/selectors";
import {setPeopleSearchFilters} from "features/pages/people/search/reducer";
import {useMediaQuery} from "services/utils/utils";
import {
    MOBILE_MEDIA_QUERY_THRESHOLD,
    PEOPLE_ORDER_BY,
    REFERENCE_SECTORS,
    COMPANY_ROLES, EMPLOYEES
} from "constants.js";
import {Icon} from "features/components/icon";
import {TextField} from "features/components/text-field";
import {__} from "services/i18n";
import Button from "features/components/button";
import Select from "features/components/select";
import {LoadingLogoPortal} from "features/components/loading-logo";
import {withTranslation} from "react-i18next";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: peopleSearchLoading(state),
    filters: peopleSearchFilters(state),
    categories: staticDataInterests(state),
    osa_offices: staticDataOsaOffices(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    setPeopleSearchFilters
};

export const PeoplePage = (props) => {
    const {loading, filters, categories, osa_offices, t} = props;
    const {setPeopleSearchFilters} = props;
    const setFilterValue = useCallback((key, value) => {
        setPeopleSearchFilters({
            [key]: value
        })
    }, [setPeopleSearchFilters]);

    const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY_THRESHOLD);
    const [openFilters, setOpenFilters] = useState(false);
    const toggleOpenFilters = useCallback(() => {
        setOpenFilters(!openFilters);
    }, [openFilters, setOpenFilters]);

    const firstRowFilter = useMemo(() => {
        return <>
            <Select
                value={filters.sector}
                onChange={(val) => setFilterValue("sector", val)}
                values={[{key: "all", value: t("common.all.male")}, ...REFERENCE_SECTORS]}
                placeholder={__("people.filters.sector")}
                noSelectionString={__("common.all.female")}
            />
            <Select
                value={filters.osa_hq}
                onChange={(val) => setFilterValue("osa_hq", val)}
                values={[{key: "all", value: t("common.all.male")}, ...osa_offices]}
                placeholder={__("people.filters.osa_hq")}
                noSelectionString={__("common.all.male")}
            />
            <Select
                value={filters.order_by}
                onChange={(val) => setFilterValue("order_by", val)}
                values={PEOPLE_ORDER_BY}
                placeholder={__("common.order-by.placeholder")}
                noSelectionString={__("people.filters.order-by.default")}
            />
            </>
    }, [filters.order_by, filters.osa_hq, filters.sector, osa_offices, setFilterValue, t]);

    const filtersRow = useMemo(() => {
        return <div className="row filters">
            <div className={"first-row"}>
                <div className={"search"}>
                    <Icon>search</Icon>
                    <TextField type={"text"} value={filters.search} onChange={(val) => setFilterValue("search", val)} placeholder={__("threads.filters.search")} />
                    {!!filters.search && <div className="reset" onClick={() => setFilterValue("search", "")}><Icon>close</Icon></div>}
                </div>
                {!isMobile && firstRowFilter}
                <div className="show-filters">
                    <Button title={__("buttons.show-filters")} onClick={toggleOpenFilters} type={"outlined"} icon={openFilters ? "arrow-dropdown-up" : "arrow-dropdown-down"} />
                </div>
            </div>
            <div className={`choices ${openFilters ? "show" : "hide"}`}>
                {isMobile && firstRowFilter}
                <Select
                    value={filters.category}
                    onChange={(val) => setFilterValue("category", val)}
                    multiple={false}
                    values={[{key: "all", value: t("common.all.female")}, ...categories]}
                    placeholder={__("people.filters.categories")}
                />
                <Select
                    value={filters.role}
                    onChange={(val) => setFilterValue("role", val)}
                    multiple={false}
                    values={[{key: "all", value: t("common.all.male")}, ...COMPANY_ROLES]}
                    placeholder={__("people.filters.roles")}
                />
                <Select
                    value={filters.company_size}
                    onChange={(val) => setFilterValue("company_size", val)}
                    values={[{key: "all", value: t("people.filters.all_companies")}, ...EMPLOYEES]}
                    placeholder={__("people.filters.company_size")}
                    noSelectionString={__("common.all.female")}
                />
            </div>
        </div>
    }, [categories, filters.category, filters.company_size, filters.role, filters.search, firstRowFilter, isMobile, openFilters, setFilterValue, t, toggleOpenFilters]);


    return <LoggedInLayout type={"light"}
                           className={"people-page"}
                           breadcrumbs={[{title: "common.home-breadcrumb", link:"/"}, {title: "people.breadcrumb"}]}
    >
        {loading && <LoadingLogoPortal />}
        {filtersRow}
        <PeopleHighlights />
        <PeopleFavorites />
        <PeopleSearchResults />
    </LoggedInLayout>
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PeoplePage));